window.AdminLogin = function AdminLogin({ onLoginSuccess }) {
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState('');
  const [showPassword, setShowPassword] = React.useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await window.apiClient.post('auth.php?action=login', { username, password });
      
      const user = res.user || (res.data && res.data.user);
      if (res.success && user) {
        onLoginSuccess(user);
      } else {
        setError(res.message || (res.data && res.data.message) || 'Invalid login credentials.');
      }
    } catch (err) {
      setError(err.message || 'Login failed. Please verify your credentials and server connection.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4 selection:bg-orange-500 selection:text-white">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-2xl shadow-xl overflow-hidden animate-fadeIn">
        
        {/* Header */}
        <div className="p-8 text-center border-b border-slate-100 space-y-3 bg-slate-50">
          <div className="bg-white px-4 py-2 rounded-xl inline-block shadow-sm border border-slate-200">
            <img src="/logo.png" alt="NOVATEK Logo" className="h-10 w-auto object-contain mx-auto" />
          </div>
          <h2 className="font-serif text-2xl font-bold text-slate-900 tracking-tight">Admin Portal Access</h2>
          <p className="font-mono text-xs text-slate-500">NOVATEK Industrial Systems Management</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-8 space-y-5">
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 p-3.5 rounded-lg text-xs font-mono flex items-center gap-2">
              <span className="material-symbols-outlined text-base">error</span>
              <span>{error}</span>
            </div>
          )}

          <div>
            <label className="block font-mono text-xs font-bold text-slate-600 uppercase tracking-wider mb-2">
              Username or Email
            </label>
            <div className="relative">
              <span className="material-symbols-outlined absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400 text-lg">
                person
              </span>
              <input
                type="text"
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="admin@novatekindustrial.com"
                className="w-full pl-10 pr-4 py-3 bg-slate-50 border border-slate-300 rounded-lg text-sm text-slate-900 focus:outline-none focus:border-secondary transition-colors"
              />
            </div>
          </div>

          <div>
            <label className="block font-mono text-xs font-bold text-slate-600 uppercase tracking-wider mb-2">
              Password
            </label>
            <div className="relative">
              <span className="material-symbols-outlined absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400 text-lg">
                lock
              </span>
              <input
                type={showPassword ? "text" : "password"}
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full pl-10 pr-10 py-3 bg-slate-50 border border-slate-300 rounded-lg text-sm text-slate-900 focus:outline-none focus:border-secondary transition-colors font-mono"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 focus:outline-none"
              >
                <span className="material-symbols-outlined text-lg">
                  {showPassword ? "visibility_off" : "visibility"}
                </span>
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-secondary hover:bg-orange-600 text-white font-mono text-xs font-bold uppercase tracking-widest py-3.5 rounded-lg transition-all shadow-md flex items-center justify-center gap-2 disabled:opacity-50 cursor-pointer"
          >
            {loading ? (
              <span>Authenticating...</span>
            ) : (
              <>
                <span className="material-symbols-outlined text-base">login</span>
                <span>Secure Sign In</span>
              </>
            )}
          </button>
        </form>

      </div>
    </div>
  );
};
